module.exports = __webpack_public_path__ + "img/line.0634b993.svg";